import { render, staticRenderFns } from "./dataPackageDetail.vue?vue&type=template&id=b86bfe80&scoped=true"
import script from "./dataPackageDetail.vue?vue&type=script&lang=js"
export * from "./dataPackageDetail.vue?vue&type=script&lang=js"
import style0 from "./dataPackageDetail.vue?vue&type=style&index=0&id=b86bfe80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86bfe80",
  null
  
)

export default component.exports